// extracted by mini-css-extract-plugin
export default {"swiper-pagination":"styles_swiper-pagination__92++B"};